export default {
  free: 'GRATUIT',
  save: 'Économisez {{amount}}',
};
